import Promise from "bluebird";
import {baseUrl} from "../config";
import ListUtils from "./ListUtils";
import NumberUtils from "./NumberUtils";
import session from "./Session";
import axios from "axios";
import router from '../router'

// To add to window
if (!window.Promise) {
  window.Promise = Promise
}

// 请求拦截
axios.interceptors.request.use(function (config) {
  // 处理请求之前的配置
  /*if (session.isLogin()) {
    var token = session.getAccountToken().token || '';
    if (session.getInLight()){
      token  = session.get('lightToken') || '';
    }
    config.headers.authorization = token
  }*/
  let ua = navigator.userAgent.toLowerCase();
  let env = '2'
  if(ua.match(/MicroMessenger/i) == 'micromessenger') {
    env = '1';
  }else if(ua.match(/newsmthApp/i) == 'newsmthapp'){
    env = '3'
  }
  config.headers.env = env;
  return config
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error)
});
async function beforeRequest(option) {

  if (!option){
    option = {};
  }
  if(!option.headers){
    option.headers = {}
  }
  let isLogin = await session.isLogin();
  if (isLogin) {
    const token = await session.getToken();
    option.headers.authorization = token
  }else{
    option.headers.authorization = ''
  }
  let ua = navigator.userAgent.toLowerCase();
  let env = '2'
  if(ua.match(/MicroMessenger/i) == 'micromessenger') {
    env = '1';
  }
  option.headers.env = env;
  return option;
}

const requestGet = (url = '', data = {}) => {
  var result = request('get', url, data)
  return result
}
const requestPost = (url = '', data = {}) => {
  var result = request('post', url, data)
  return result
}
const uploadFile = (url = '', data = {}) => {
  return new Promise(function (resolve, reject) {
    var boundary = NumberUtils.uuid()
    var option = {
      baseURL: baseUrl,
      headers: { 'Content-Type': 'multipart/form-data;boundary=' + boundary },
      withCredentials: true
    }
    var formData = new FormData()
    for (var key in data) {
      if (ListUtils.isArray(data[key])) {
        for (var value of data[key]) {
          formData.append(key, value)
        }
      } else {
        formData.append(key, data[key])
      }
    }
    beforeRequest(option).then(option => {
      axios.post(url, formData, option).then((response) => {
        if (response.status === 200) {
          var result = response.data
          if (result.code === '0' || result.code === '1') {
            resolve(response.data)
          } else {
            reject(new Error(response.statusText))
          }
        } else {
          reject(new Error(response.statusText))
        }
      }).catch((e) => {
        console.error('上传文件失败====', e)
        reject(e)
      })
    });
  })
}

const request = (type = 'get', url = '', data = {}) => {
  return new Promise((resolve, reject)=> {
    type = type.toLowerCase()
    var option = {
      url: url,
      baseURL: baseUrl,
      method: type,
      transformRequest: [
        function (data) {
          let ret = ''
          for (let it in data) {
            if (ListUtils.isArray(data[it])) {
              data[it] && data[it].forEach((item) => {
                ret += encodeURIComponent(it) +
                  '=' +
                  encodeURIComponent(item) +
                  '&'
              })
            } else {
              ret += encodeURIComponent(it) +
                '=' +
                encodeURIComponent(data[it]) +
                '&'
            }
          }
          return ret
        }
      ],
      withCredentials: true,
      // 查询对象序列化函数
      paramsSerializer: function (params) {
        let ret = ''
        for (let it in params) {
          if (ListUtils.isArray(params[it])) {
            params[it] && params[it].forEach((item) => {
              ret += encodeURIComponent(it) +
                '=' +
                encodeURIComponent(item) +
                '&'
            })
          } else {
            ret += encodeURIComponent(it) +
              '=' +
              encodeURIComponent(params[it]) +
              '&'
          }
        }
        if (ret) {
          ret = ret.substring(0, ret.length - 1)
        }
        return ret
      }
    }

    if (type === 'get') {
      option.params = data
    } else {
      option.data = data
    }
    beforeRequest(option).then(option => {
      _request(option).then(result => {
        const {code} = result;
        if (code === 401) {
          console.log('['+ option.url +']登录失效==============', result)
          const { gzhOpenid = '' } = session.getAccountToken() || {}
          if (gzhOpenid) {
            requestPost('/customer/user/wechat/login', { openid: gzhOpenid }).then(res => {
              console.log('使用openid重新登录==============', res)
              session.accountToken(res.data);
              session.login(res.data).then(() => {
                beforeRequest(option).then(option => {
                  _request(option).then(resultSecond => {
                    console.log('重新请求返回==============', resultSecond)
                    resolve(resultSecond);
                  }).catch(e => {
                    reject(e)
                  });
                }).catch(e => {
                  reject(e)
                })
              }).catch(e => {
                reject(e)
              });
            }).catch(e => {
              reject(e)
            });
          } else {
            reject(new Error('登录失效，请重新登录'))
          }
        } else {
          resolve(result);
        }
      });
      /*axios.request(option).then((response) => {
        if (response.status === 200) {
          var result = response.data;
          const {code} = result;
          if (code === 401) {
            const { gzhOpenid = '' } = session.getAccountToken() || {}
            if (gzhOpenid) {
              requestPost('/customer/user/wechat/login', { openid: gzhOpenid }).then(res => {
                session.logout();
                session.accountToken(res.data);
                session.login(res.data).then(() => {
                  requestPost(type, url, data);
                }).catch(e => {
                  reject(e)
                });
              }).catch(e => {
                reject(e)
              });
            } else {
              reject(new Error('登录失效，请重新登录'))
            }
          } else {
            resolve(result);
          }
        } else {
          reject(new Error(response.statusText))
        }
      }).catch((e) => {
        reject(e)
      })*/
    });

    function _request(option) {
      return new Promise((resolve, reject) => {
        axios.request(option).then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          } else {
            reject(new Error(response.statusText))
          }
        }).catch((e) => {
          reject(e)
        })
      });
    }
  })
}
export default {get: requestGet, post: requestPost, upload: uploadFile}
